import { Skeleton } from "@/components/ui/skeleton";

export function SimuladorChatSkeleton() {
  return (
    <div
      className="flex min-h-[calc(100dvh-8.5rem)] flex-col overflow-hidden rounded-xl border border-border/50 bg-background"
      data-testid="simulador-chat-skeleton"
    >
      <div className="flex flex-wrap items-center gap-3 border-b border-border/50 bg-card/60 px-4 py-3">
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-5 w-64 max-w-[80%]" />
          <Skeleton className="h-3 w-40 max-w-[55%]" />
        </div>
        <Skeleton className="h-6 w-44 rounded-full" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-28 rounded-full" />
          <Skeleton className="h-6 w-16 rounded-full" />
          <Skeleton className="h-8 w-20 rounded-lg" />
        </div>
      </div>

      <div className="flex flex-1 min-h-0 flex-col justify-end px-4 py-4">
        <div className="space-y-3">
          <div className="flex justify-start">
            <Skeleton className="h-24 w-[72%] rounded-2xl rounded-bl-sm" />
          </div>
          <div className="flex justify-end">
            <Skeleton className="h-16 w-[38%] rounded-2xl rounded-br-sm" />
          </div>
          <div className="flex justify-start">
            <Skeleton className="h-20 w-[68%] rounded-2xl rounded-bl-sm" />
          </div>
          <div className="flex justify-start">
            <Skeleton className="h-12 w-20 rounded-2xl rounded-bl-sm" />
          </div>
        </div>
      </div>

      <div className="border-t border-border/50 bg-card/60 px-3 py-3">
        <div className="flex items-end gap-2">
          <Skeleton className="h-10 w-10 rounded-md" />
          <Skeleton className="h-10 w-10 rounded-md" />
          <Skeleton className="h-[42px] flex-1 rounded-xl" />
          <Skeleton className="h-10 w-10 rounded-md" />
        </div>
      </div>
    </div>
  );
}
